import styled from 'styled-components';

import { PRIMARY } from 'constants/colors';

import { brightness } from 'utils/misc';

export default styled.div`
  position: relative;

  .add-new-btn {
    position: absolute;
    top: 0;
    right: 0;
  }

  table {
    width: auto;

    td {
      padding-left: 0;
      padding-right: 0;
      border: 0;
    }
  }

  td.contact-type {
    padding-right: 20px;
    vertical-align: top;

    .name {
      padding: 2px 0;
    }
  }

  .contact-cell {
    width: 800px;
  }

  .contact {
    border: 1px solid ${PRIMARY};
    border-radius: 4px;
    background-color: ${brightness(PRIMARY, 90)};
    padding: 14px 20px;
    position: relative;

    + .contact {
      margin-top: 10px;
    }

    .name {
      width: 330px;
      flex-shrink: 0;
      font-size: 16px;
      font-family: 'signikasemibold';
    }

    .phone-email {
      width: 200px;
      flex-shrink: 0;
    }

    .remarks {
      width: 200px;
    }

    .contact-actions {
      margin-left: 30px;
      flex-grow: 1;
    }
  }
`;
